
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff/user",
      function () {
        return require("private-next-pages/staff/user/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff/user"])
      });
    }
  